import { Controller } from "@hotwired/stimulus"

// Auto-dismisses flash toasts after a delay; supports manual dismissal.
export default class extends Controller {
  static targets = ["toast"]
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timers = this.toastTargets.map((toast) =>
      setTimeout(() => this.remove(toast), this.delayValue)
    )
  }

  disconnect() {
    ;(this.timers || []).forEach(clearTimeout)
  }

  dismiss(event) {
    this.remove(event.target.closest(".toast"))
  }

  remove(toast) {
    if (!toast) return
    toast.classList.add("is-leaving")
    toast.addEventListener("animationend", () => toast.remove(), { once: true })
  }
}
